import React, { useEffect } from 'react';
import './Page.scss';
import PageNav from '../PageNav';
import AppNav from '../AppNav';
import cn from 'classnames';

interface IPage {
  children: any;
  navLinks?: any;
  navHeading?: any;
  heading?: any;
}

const Page: React.FC<IPage> = ({ children, navLinks = undefined, navHeading = undefined, heading = undefined }) => {
  // Scroll back to the top of the viewport whenever the page content changes
  useEffect(() => {
    const viewport = document.getElementsByClassName('Page-Viewport')[0];
    if (viewport) viewport.scrollTop = 0;
  }, [children]);

  return (
    <div className={cn('Page', { 'Page-hideAppNav': !!window.qest.isFrame }, { 'Page-hidePageNav': !navLinks })}>
      {!window.qest.isFrame && <AppNav />}
      {navLinks && <PageNav links={navLinks} heading={navHeading} />}
      <div className="Page-Viewport">
        <main className="Page-Content">
          {heading && <h1 className="Page-Heading">{heading}</h1>}
          {children}
        </main>
      </div>
    </div>
  );
};

export default Page;
